import { Heading } from "monday-ui-react-core/next";
import Classes from "./Header.module.scss";

const Header = () => {
  return (
    <Heading type={Heading.types.H1} className={Classes.header} maxLines={4}>
      {"מחשבון ריבית דריבית - השקעות לעצלנים"}
    </Heading>
  );
};

export default Header;
